import React from 'react';
import Icon from "../Icon";
import NotificationDot from "../NotificationDot";

const NotificationButton = ({className}) => {
  return (
    <div className={`notification-button s-relative cursor-pointer s-cross-center ${className}`}>
      <NotificationDot className="s-absolute s-right-4px s-top-4px"/>
      <Icon
        svg="bell"
        size="24px"
      />
    </div>
  );
};

export default NotificationButton;
